import React, { useEffect } from "react";
import { Routes, Route, useNavigate, Outlet, Navigate } from 'react-router-dom';
import Sidebar from "../components/common/sidebar/Sidebar";
import VideoLayer from "../components/video-layering/VideoLayer";
import VideoLayerTopic from "../components/video-layering/VideoLayerTopic";
import VideoLayerContent from "../components/video-layering/VideoLayerContent";
import QbLayer from "../components/Qbanks/QbLayer";
import QbTopics from "../components/Qbanks/QbTopics";
import QbLayerContent from "../components/Qbanks/QbLayerContent";
import QbInstructions from "../components/Qbanks/QbInstructions";
import QbAttempt from "../components/Qbanks/QbAttempt";
import QbPerformance from "../components/Qbanks/QbPerformance";
import QbAllSolution from "../components/Qbanks/QbAllSolution";
import ViewAllListing from "../components/ViewAllListing/ViewAllListing";
import TestLayer from "../components/Tests/TestLayer";
import TestContent from "../components/Tests/TestContent";
import TestByYear from "../components/Tests/TestByYear";
import TestInstructions from "../components/Tests/TestInstructions";
import TestAttempt from "../components/Tests/TestAttempt";
import TestPerformance from "../components/Tests/TestPerformance";
import TestAllSolution from "../components/Tests/TestAllSolution";
import TestTopicAnalysis from "../components/Tests/TestTopicAnalysis";
import TestFlowAttempt from "../components/Tests/TestFlowAttempt";
import AccountsHome from "../components/Accounts/AccountsHome";
import Settings from "../components/Accounts/Settings";
import MyBookmarks from "../components/Accounts/MyBookmarks";
import EditProfile from "../components/Accounts/EditProfile";
import MyActivePlans from "../components/Accounts/MyActivePlans";
import MyOrder from "../components/Accounts/MyOrder";
import OrderDetail from "../components/Accounts/OrderDetail";
import ContactUs from "../components/Accounts/ContactUs";
import OtherResource from "../components/video-layering/VideoOtherResource";
import QbOtherResource from "../components/Qbanks/QbOtherResource";
import MantraHome from "../components/Mantras/MantraHome";
import MantraListing from "../components/Mantras/MantraListing";
import MantraContent from "../components/Mantras/MantraContent";
import SignUp from "../components/Register/SignUp";
import PreHeader from "../components/common/header/PreHeader";
import LogInHome from "../components/Register/LogInHome";
import QbAllAttempt from "../components/Qbanks/QbAllAttempt";
import TestAllAttempt from "../components/Tests/TestAllAttempt";
import SubscriptionHome from "../components/Subscriptions/SubscriptionHome";
import SubscriptionPlan from "../components/Subscriptions/SubscriptionPlan";
import PlanExtention from "../components/Subscriptions/PlanExtention";
import PlanAddons from "../components/Subscriptions/PlanAddons";
import SingleSubscription from "../components/Subscriptions/SingleSubscription";
import CustomQbHome from "../components/CustomQB/CustomQbHome";
import ProtectedRoute from "./protectedRoute";
import Addons from "../components/Subscriptions/Addon";
import Success from "../components/common/Transactions/Success";
import Error from "../components/common/Transactions/Error";
import { decryptdata } from "../utils/crypto";
import Pending from "../components/common/Transactions/Pending";
import MyQuestionBookmarksViewAllSolution from "../components/Accounts/MyQuestionBookmarkAllsolution";
function Routing() {
    const navigate = useNavigate()
    let token = null
    try {
        token = decryptdata(localStorage.getItem('token'));
    } catch (error) {
        navigate('/onboarding/login')
    }
    const Userheader = () => {
        return (
            <>
                <PreHeader />
                <Outlet />
            </>
        )
    }

    const PackageSuccess = () => {
        return (
            <>
                <Outlet />
            </>
        )
    }

    const TestAttemptNew = () => {
        return (
            <>
                <Outlet />
            </>
        )
    }

    return (
        <Routes>
            {!token ? (
                <Route exact path={"/"} element={<LogInHome />} />
            ) : (
                <>
                    <Route exact path='/' element={<Sidebar />} >
                        <Route exact path={"/"} element={<Navigate to="/videolayer" replace />} />
                    </Route>
                </>
            )}
            <Route path='/' element={<Sidebar />}>
                <Route exact path="videolayer" element={<ProtectedRoute> <VideoLayer /></ProtectedRoute>} />
                <Route exact path="videolayer/:id" element={<ProtectedRoute><VideoLayerTopic /></ProtectedRoute>} />
                <Route exact path="videolayer/otherResource/:id" element={<ProtectedRoute><OtherResource /></ProtectedRoute>} />
                <Route exact path="videolayer/videolayerContent/:id" element={<ProtectedRoute><VideoLayerContent /></ProtectedRoute>} />
                <Route exact path="videolayerContent/:id" element={<ProtectedRoute><VideoLayerContent /></ProtectedRoute>} />
                <Route exact path="qblayer" element={<ProtectedRoute><QbLayer /></ProtectedRoute>} />
                <Route exact path="qblayer/:id" element={<ProtectedRoute><QbTopics /></ProtectedRoute>} />
                <Route exact path="qblayer/qblayercontent/:id" element={<ProtectedRoute><QbLayerContent /></ProtectedRoute>} />
                <Route exact path="qblayer/qball/:id/:name/:indexs" element={<ProtectedRoute><QbAllAttempt /></ProtectedRoute>} />
                <Route exact path="qblayer/qbinstructions/:id/:name" element={<ProtectedRoute><QbInstructions /></ProtectedRoute>} />
                <Route exact path="qblayer/qbattempt/:id/:name" element={<ProtectedRoute><QbAttempt /></ProtectedRoute>} />
                <Route exact path="qblayer/qballsolution/:id/:name" element={<ProtectedRoute><QbAllSolution /></ProtectedRoute>} />
                <Route exact path="qblayer/qbperformance/:id/:name" element={<ProtectedRoute><QbPerformance /></ProtectedRoute>} />
                <Route exact path="qblayer/QbOtherResource/:id" element={<ProtectedRoute><QbOtherResource /></ProtectedRoute>} />
                <Route exact path="qblayer/viewAll" element={<ProtectedRoute><ViewAllListing /></ProtectedRoute>} />
                <Route exact path="testlayer" element={<ProtectedRoute><TestLayer /></ProtectedRoute>} />
                <Route exact path="testlayer/:id" element={<ProtectedRoute><TestContent /></ProtectedRoute>} />
                <Route exact path="testlayer/testbyyear/:id" element={<ProtectedRoute><TestByYear /></ProtectedRoute>} />
                <Route exact path="testlayer/testinstruction/:id" element={<ProtectedRoute><TestInstructions /></ProtectedRoute>} />
                <Route exact path="testlayer/testattempt/:id" element={<ProtectedRoute><TestAttempt /></ProtectedRoute>} />
                <Route exact path="testlayer/testperformance/:id" element={<ProtectedRoute><TestPerformance /></ProtectedRoute>} />
                <Route exact path="testlayer/testTopicAnalysis/:id" element={<ProtectedRoute><TestTopicAnalysis /></ProtectedRoute>} />
                <Route exact path="testlayer/viewallsolution/:id" element={<ProtectedRoute><TestAllSolution /></ProtectedRoute>} />
                <Route exact path="testlayer/all/:id/:indexs" element={<ProtectedRoute><TestAllAttempt /></ProtectedRoute>} />
                <Route exact path="account" element={<ProtectedRoute><AccountsHome /></ProtectedRoute>} />
                <Route exact path="account/setting" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                <Route exact path="account/mybookmarks" element={<ProtectedRoute><MyBookmarks /></ProtectedRoute>} />
                <Route exact path="account/editProfile" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
                <Route exact path="account/myorder" element={<ProtectedRoute><MyOrder /></ProtectedRoute>} />
                <Route exact path="account/orderdetail" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
                <Route exact path="account/myActivePlan" element={<ProtectedRoute><MyActivePlans /></ProtectedRoute>} />
                <Route exact path="account/contactUs" element={<ProtectedRoute><ContactUs /></ProtectedRoute>} />
                <Route exact path="mantras" element={<ProtectedRoute><MantraHome /></ProtectedRoute>} />
                <Route exact path="mantras/mantraslisting/:id" element={<ProtectedRoute><MantraListing /></ProtectedRoute>} />
                <Route exact path="mantras/mantrascontent/:index/:id/:text/:subindex" element={<ProtectedRoute><MantraContent /></ProtectedRoute>} />
                <Route exact path="package" element={<ProtectedRoute><SubscriptionHome /></ProtectedRoute>} />
                <Route exact path="package/:name" element={<ProtectedRoute><SubscriptionHome /></ProtectedRoute>} />
                <Route exact path="package/plan/:id" element={<ProtectedRoute><SubscriptionPlan /></ProtectedRoute>} />
                <Route exact path="package/planAddons/:id" element={<ProtectedRoute><PlanAddons /></ProtectedRoute>} />
                <Route exact path="package/Addons/:id" element={<ProtectedRoute><Addons /></ProtectedRoute>} />
                <Route exact path="package/extension" element={<ProtectedRoute><PlanExtention /></ProtectedRoute>} />
                <Route exact path="package/singleSubscription" element={<ProtectedRoute><SingleSubscription /></ProtectedRoute>} />
                <Route exact path="view/all/:name" element={<ProtectedRoute><ViewAllListing /></ProtectedRoute>} />
                <Route exact path="customQB" element={<ProtectedRoute><CustomQbHome /></ProtectedRoute>} />
                <Route exact path="account/mybookmarks/viewSolution" element={<ProtectedRoute><MyQuestionBookmarksViewAllSolution /></ProtectedRoute>} />
            </Route>

            <Route path="/" element={<PackageSuccess />}>
                <Route exact path="success/:title/:validity" element={<Success />} />
                <Route exact path="error" element={<Error />} />
                <Route exact path="pending" element={<Pending />} />
            </Route>

            <Route path="/" element={<TestAttemptNew />}>
                <Route exact path="testlayer/newTestAttempt/:id" element={<TestFlowAttempt />} />
            </Route>


            <Route path="/" element={<Userheader />}>
                <Route path='/onboarding/signup' element={<SignUp />} />
                <Route path='/onboarding/login' element={<LogInHome />} />
            </Route>
        </Routes>
    );
}
export default Routing;
